import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import CtaForm from 'Component/CtaForm/CtaForm';
import css from './CtaSection.module.scss';

const CtaSection = ({
	heading,
	subheading,
	aboutText,
	aboutTextLink,
	aboutTextLinkUrl,
	customClass,
	auth,
}) => {
	return (
		<div className={classNames(css.ctaSection, css[customClass])}>
			<div className={css.contentWrapper}>
				<h3>{heading}</h3>
				{subheading !== undefined && <h4>{subheading}</h4>}
				{auth ? (
					<div className={css.authBtns}>
						<Link to="#">
							<button className="btn btnGreen">Sign up</button>
						</Link>
						<Link to="#">
							<button className="btn btnOverline">Login</button>
						</Link>
					</div>
				) : (
					<CtaForm customClass={customClass} />
				)}

				{aboutText !== undefined && (
					<div className={css.about}>
						{aboutText}{' '}
						<Link to={aboutTextLinkUrl} className="linkUnderline">
							{aboutTextLink}
						</Link>
					</div>
				)}
			</div>
		</div>
	);
};

export default CtaSection;
